import React from 'react';
import PropTypes from 'prop-types';
import { getFaro } from 'flow/api-clients/faro-client';
import { withRouter } from 'react-router';

import ErrorBoundaryView from 'flow/components/error-boundary/ErrorBoundaryView';
import { addGeneralLogEntry } from 'flow/utils/browser-utils';

class ContentPaneErrorBoundary extends React.Component {
    static propTypes = {
        children: PropTypes.node.isRequired,
        history: PropTypes.object, // eslint-disable-line react/forbid-prop-types
        location: PropTypes.object, // eslint-disable-line react/forbid-prop-types
    };
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            this.state.hasError &&
            prevState.hasError &&
            this.props.location.pathname !== prevProps.location.pathname
        ) {
            this.setState({ hasError: false });
        }
    }

    componentDidCatch(error, _info) {
        getFaro()?.api.pushError(error, {
            context: { component: 'ContentPane', severity: 'critical' },
        });
        addGeneralLogEntry(`Error reported: ${error}`);
    }

    onRetry = () => {
        const { history } = this.props;
        history.goBack();
    };

    render() {
        if (this.state.hasError) {
            return <ErrorBoundaryView onClick={this.onRetry} />;
        }

        return this.props.children;
    }
}

export default withRouter(ContentPaneErrorBoundary);
